import React from 'react';
import styles from './Comparison.module.css';

const comparisonData = [
  {
    ana: 'AI as Autonomous Engineer',
    copilot: 'AI as Code completion'
  },
  {
    ana: 'Autonomous and Assistant',
    copilot: 'Assistant Only'
  },
  {
    ana: 'Applies AI Architecture',
    copilot: 'Predicts coding type/pattern'
  },
  {
    ana: 'Works with large and complex repos',
    copilot: 'Current and adjacent files'
  },
  {
    ana: 'Multiple deployment options',
    copilot: 'SaaS'
  }
];

const Comparison: React.FC = () => {
  return (
    <section className={styles.section} id="comparison">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Ana vs Coding Assistant</h2>
          <p className={styles.subtitle}>
            See how Ana compares to traditional AI coding assistants
          </p>
        </div>

        <div className={styles.comparisonTable}>
          <div className={styles.tableHeader}>
            <div className={styles.column}>Ana</div>
            <div className={styles.column}>Coding Assistant</div>
          </div>
          
          {comparisonData.map((item, index) => (
            <div key={index} className={styles.row}>
              <div className={styles.column}>
                <div className={styles.feature}>{item.ana}</div>
              </div>
              <div className={styles.column}>
                <div className={styles.feature}>{item.copilot}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Comparison;
